$(document).on('click', '[data-behavior-remove-element]', function (e) {
  e.preventDefault();
  $($(this).data('behavior-remove-element')).remove();
});

